import i18n from './tools/i18n'
let baseUrl
if(i18n.locale === 'th') {
  baseUrl = '//api.longtuthailand.com'
} else if(i18n.locale === 'vn') {
  baseUrl = 'http://api.gamebao.vn'
}
const config =  {
  httpBaseUrl: baseUrl
}
export default config



// WEBPACK FOOTER //
// ./src/config.js